// @ts-expect-error untyped dependency
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import FormattedMessage from 'I18n/components/FormattedMessage';
import emptyFunction from 'react-utils/emptyFunction';
import AbstractTextElement from 'UIComponents/elements/AbstractTextElement';
import Small from 'UIComponents/elements/Small';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AssetProviderProfile({
  onTrackInteraction = emptyFunction,
  providerAvatarSize = 48,
  providerWebsiteAnalyticsId,
  provider,
  use = 'default'
}) {
  const MetadataText = use === 'sidebar' ? Small : AbstractTextElement;
  const {
    avatarUrl,
    location,
    name,
    websiteUrl
  } = provider;
  return /*#__PURE__*/_jsxs(UIMediaObject, {
    align: "center",
    itemLeft: /*#__PURE__*/_jsx("div", {
      style: {
        width: providerAvatarSize
      },
      children: /*#__PURE__*/_jsx(UIAvatar, {
        size: "responsive",
        src: avatarUrl,
        type: "contact"
      })
    }),
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-100",
      marginBlockEnd: use === 'default' ? '200' : '0',
      children: name
    }), /*#__PURE__*/_jsxs(UIList, {
      inline: true,
      use: "inline-divided",
      children: [use === 'default' && location && /*#__PURE__*/_jsx(MetadataText, {
        children: location
      }), /*#__PURE__*/_jsx(MetadataText, {
        children: /*#__PURE__*/_jsx(UILink, {
          "data-hs-analytics-id": providerWebsiteAnalyticsId,
          external: true,
          href: websiteUrl,
          onClick: () => onTrackInteraction('click provider link'),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-ui-assets-core.details.providerInfo.website"
          })
        })
      })]
    })]
  });
}